import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
@Component({
    selector: 'app-password-meter',
    templateUrl: './password-meter.component.html',
    styleUrls: ['./password-meter.component.scss'],
    standalone: false
})
export class PasswordMeterComponent implements OnChanges {
    @Input() password: string = '';
    strengthLevels: string[] = ['inactive', 'inactive', 'inactive', 'inactive'];
    constructor() {
    }
    ngOnChanges(changes: SimpleChanges) {
        if (changes['password']) {
            this.checkPasswordStrength(this.password);
        }
    }
    private checkPasswordStrength(password: string): void {
        let strength = 0;

        if(password === null){
            return
        }
        if (password.length >= 10) strength += 1;
        if (/[A-Z]/.test(password)) strength += 1;
        if (/[0-9]/.test(password)) strength += 1;
        if (/[\W]/.test(password)) strength += 1;

        for (let i = 0; i < this.strengthLevels.length; i++) {
            if (i < strength) {
                this.strengthLevels[i] = ['weak', 'medium', 'good', 'strong'][i];
            } else {
                this.strengthLevels[i] = 'inactive';
            }
        }
    }

}
